// Colours of the Market Booking Curve chart: the Tailwind values of the page
// (blue-500, amber-500, gray-200, gray-400, gray-500, white), as the demand strip keeps
// its cluster colours in a constant.
export const marketBookingCurveColors = {
	paper: '#ffffff',
	occupancy: '#3b82f6',
	rate: '#f59e0b',
	grid: '#e5e7eb',
	muted: '#9ca3af',
	text: '#6b7280',
};
